// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"
import "swiper/css/bundle"

// Application controllers

import Carousel from '@stimulus-components/carousel'
application.register('carousel', Carousel)

import GalleryController from "./gallery_controller"
application.register("gallery", GalleryController)

import Collapse from './collapse_controller'
application.register('collapse', Collapse)

import DisabledController from "./disabled_controller"
application.register("disabled", DisabledController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import HighchartsController from "./highcharts_controller"
application.register("highcharts", HighchartsController)

import MnemonicInputController from "./mnemonic_input_controller"
application.register("mnemonic-input", MnemonicInputController)


import MtPelerinController from "./mt_pelerin_controller"
application.register("mt-pelerin", MtPelerinController)

// import PdfController from "./offline/pdf_controller"
// application.register("pdf", PdfController)

import PermissionController from "./permission_controller"
application.register("permission", PermissionController)

import PreviewController from "./preview_controller"
application.register("preview", PreviewController)

import ProgressController from "./progress_controller"
application.register("progress", ProgressController)

import PhotoSelectController from "./photo_select_controller"
application.register("photo-select", PhotoSelectController)

import ImageController from "./image_controller"
application.register("image", ImageController)

import QrScannerController from "./qr_scanner_controller"
application.register("qr-scanner", QrScannerController)

import QrScannerLauncherController from "./qr_scanner_launcher_controller"
application.register("qr-scanner-launcher", QrScannerLauncherController)

import TabsController from "./tabs_controller"
application.register("tabs", TabsController)


import ToggleController from './toggle_controller'
application.register('toggle', ToggleController)

import PlacesAutocompleteController from './places_autocomplete_controller'
application.register('places-autocomplete', PlacesAutocompleteController)

import PhoneInputController from './phone_input_controller'
application.register('phone-input', PhoneInputController)

import PasswordMeterController from './password_meter_controller'
application.register('password-meter', PasswordMeterController)

import StepsController from './steps_controller'
application.register('steps', StepsController)

// To breakout of turbo frames from server e.g successful login frame we redirect to /
// https://github.com/hotwired/turbo-rails/pull/367#issuecomment-1934729149
Turbo.StreamActions.redirect = function () {
    Turbo.visit(this.target, { action: "replace" });
};

// Custom Turbo Stream action to close HTML dialog elements
// Usage: turbo_stream.action :close_dialog, "dialog-id"
Turbo.StreamActions.close_dialog = function () {
  const dialog = document.getElementById(this.target)
  if (dialog) dialog.close()
};

// Custom Turbo Stream action to dispatch window events (for cross-controller communication)
// Usage: turbo_stream.action :dispatch, "target", event: "event-name", detail: { ... }.to_json
Turbo.StreamActions.dispatch = function () {
  const eventName = this.getAttribute("event")
  const detail = JSON.parse(this.getAttribute("detail") || "{}")
  window.dispatchEvent(new CustomEvent(eventName, { detail }))
};

import { createConsumer } from "@rails/actioncable"
// Initialize Action Cable
window.App = window.App || {};
window.App.cable = createConsumer();

// Stimulus components
import Clipboard from '@stimulus-components/clipboard'
application.register('clipboard', Clipboard)

import ContentLoader from '@stimulus-components/content-loader'
application.register('content-loader', ContentLoader)

import Dialog from '@stimulus-components/dialog'
application.register('dialog', Dialog)

import Dropdown from '@stimulus-components/dropdown'
application.register('dropdown', Dropdown)

import Reveal from '@stimulus-components/reveal'
application.register('reveal', Reveal)

import ScrollReveal from '@stimulus-components/scroll-reveal'
application.register('scroll-reveal', ScrollReveal)

import ScrollTo from '@stimulus-components/scroll-to'
application.register('scroll-to', ScrollTo)

import TextareaAutogrow from 'stimulus-textarea-autogrow'
application.register('textarea-autogrow', TextareaAutogrow)

import Notification from '@stimulus-components/notification'
application.register('notification', Notification)

import { Confetti } from "stimulus-confetti"
application.register("confetti", Confetti)

import ZoomImage from '@kanety/stimulus-zoom-image'
application.register('zoom-image', ZoomImage)

import PlacesAutocomplete from "stimulus-places-autocomplete"
application.register("stimulus-places-autocomplete", PlacesAutocomplete)

import AutoSubmit from '@stimulus-components/auto-submit'
application.register('auto-submit', AutoSubmit)